const _excluded = ["children", "compact", "overrideClassName", "striped"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["align", "children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["align", "children", "overrideClassName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { cx } from "../../helpers/utils/cx";
const TableContext = /*#__PURE__*/React.createContext({
  isCompact: false,
  isStriped: false
});
export function Table(_ref) {
  let {
      children,
      compact,
      overrideClassName,
      striped
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const contextValue = React.useMemo(() => ({
    isCompact: compact,
    isStriped: striped
  }), [compact, striped]);
  return /*#__PURE__*/React.createElement(TableContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("table", _extends({
    role: "grid",
    className: cx("w-full border-collapse", overrideClassName)
  }, rest), React.Children.map(children, child => {
    return /*#__PURE__*/React.cloneElement(child);
  })));
}
function Header(_ref2) {
  let {
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("thead", rest, React.Children.map(children, child => {
    return /*#__PURE__*/React.cloneElement(child);
  }));
}
function HeaderRow(_ref3) {
  let {
      children
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("tr", rest, React.Children.map(children, child => {
    return /*#__PURE__*/React.cloneElement(child);
  }));
}
function HeaderCell(_ref4) {
  let {
      align,
      children
    } = _ref4,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  const {
    isCompact
  } = React.useContext(TableContext);
  return /*#__PURE__*/React.createElement("th", _extends({
    className: cx("p-0", align === "right" ? "text-right" : "text-left")
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-2 items-center", "text-primary bolt-font-body-s-accent", "border-0 border-b border-solid border-separator ", isCompact ? "p-1 h-8" : "h-11 px-3", align === "right" ? "justify-end" : "justify-between")
  }, children));
}
function Body(_ref5) {
  let {
      children
    } = _ref5,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement("tbody", rest, React.Children.map(children, child => {
    return /*#__PURE__*/React.cloneElement(child);
  }));
}
function Row(_ref6) {
  let {
      children
    } = _ref6,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  const {
    isStriped
  } = React.useContext(TableContext);
  return /*#__PURE__*/React.createElement("tr", _extends({
    role: "row",
    className: cx("bg-special-nulled hover:bg-active-neutral-secondary", isStriped && "odd:bg-special-zebra")
  }, rest), React.Children.map(children, child => {
    return /*#__PURE__*/React.cloneElement(child);
  }));
}
function Cell(_ref7) {
  let {
      align = "left",
      children,
      overrideClassName
    } = _ref7,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  const {
    isCompact
  } = React.useContext(TableContext);
  return /*#__PURE__*/React.createElement("td", _extends({
    className: cx("p-0 border-0 border-b border-solid border-separator align-middle", align === "left" ? "text-left" : "text-right", overrideClassName)
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: cx("w-full grid items-center", "text-primary bolt-font-body-s-regular", isCompact ? "p-1" : "p-3 min-h-12 empty:min-h-0")
  }, children));
}
Table.Header = Header;
Table.HeaderRow = HeaderRow;
Table.HeaderCell = HeaderCell;
Table.Body = Body;
Table.Row = Row;
Table.Cell = Cell;